/*
 * @Author: xinxin 18617269361@163.com
 * @Date: 2025-05-06 09:55:54
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-07-01 18:19:35
 * @FilePath: \u-h5\src\request\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/request/request";
// get /api/h5/queryPhoneList查询手机号列表
export function phoneLists(data) {
  return request({
    url: "/api/h5/queryPhoneList",
    method: "get",
    params: data,
  });
}

// /api/h5/queryPhoneInfo 号码详情 phone
export function phoneDetail(data) {
  return request({
    url: "/api/h5/queryPhoneInfo?phone=" + data,
    method: "get",
  });
}

// /api/h5/queryAddressList queryAddressList
export function queryAddressList() {
  return request({
    url: "/api/h5/queryAddressList",
    method: "get",
  });
}
// /api/h5/phoneOrderList 返回订单状态对应的数量状态(0-已取消,1-待发货，2-待付款，3-已发货，4-已退款)
export function phoneOrderList() {
  return request({
    url: "/api/h5/phoneOrderList",
    method: "get",
  });
}

// /api/h5/details 查询虚商落地页配置 nStr
export function details(data) {
  return request({
    url: "/api/h5/details",
    method: "get",
    params: data,
  });
}
// /api/h5/listByStatus 查询订单列表 status
export function listByStatus(data) {
  return request({
    url: "/api/h5/listByStatus?status=" + data,
    method: "get",
  });
}
// /api/h5/insertFeedback 新增投诉建议
export function insertFeedback(data) {
  return request({
    url: "/api/h5/insertFeedback",
    method: "post",
    data,
  });
}

// /api/h5/add 新增订单
export function addOrder(data) {
  return request({
    url: "api/h5/add",
    method: "post",
    data,
  });
}
// /system/order/${id} 订单详情 api/h5/toWaitingPay
// export function orderDetail(id) {
//   return request({
//     url: `/system/order/${id}?orderChnanel=1`,
//     method: "get",
//   });
// }
export function orderDetail(id, code) {
  return request({
    url: "api/h5/toWaitingPay?id=" + id + "&code=" + code,
    method: "get",
  });
}
// /api/h5/preOrder  下单
export function preOrder(id, platform) {
  return request({
    url: "api/h5/preOrder?id=" + id + "&platform=" + platform,
    method: "post",
  });
}
// /api/getOpenid?phone=***&jsCode=***  获取openid
export function getOpenid(phone, jsCode) {
  return request({
    url: "api/getOpenid?phone=" + phone + "&jsCode=" + jsCode,
    method: "get",
  });
}
//  /api/login/wx/phone?phone=***&jsCode=***
export function wxPhone(phone, jsCode) {
  return request({
    url: "api/login/wx/phone?phone=" + phone + "&jsCode=" + jsCode,
    method: "get",
  });
}
// 登录 /api/login/pc/phone?phone
export function login(phone) {
  return request({
    url: "/api/login/pc/phone?phone=" + phone,
    method: "get",
  });
}
// /api/sms/sendCode?phone=****
export function sendCode(phone) {
  return request({
    url: "/api/sms/sendCode?phone=" + phone,
    method: "get",
  });
}
// /api/sms/verifyCode?phone=****&code=***
export function verifyCode(phone, code) {
  return request({
    url: "/api/sms/verifyCode?phone=" + phone + "&code=" + code,
    method: "get",
  });
}
// /api/h5/queryOrder?orderId=订单id
export function queryOrder(phone) {
  return request({
    url: "/api/h5/queryOrder?orderId=" + phone,
    method: "get",
  });
}
// /api/asdUyouImageConfig/queryConfigByPlatform
export function queryConfigByPlatform(platform, type) {
  return request({
    url:
      "/api/asdUyouImageConfig/queryConfigByPlatform?platform=" +
      platform +
      "&type=" +
      type,
    method: "get",
  });
}
// /api/address/ip
export function address() {
  return request({
    url: "/api/address/ip",
    method: "get",
  });
}

//上传图片
export function uploadImage(file) {
  const formData = new FormData();
  formData.append("file", file); // 'file'是后端接收的字段名
  return request.post("/api", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
// /api/checkLogin 检查用户是否登录
export function checkLogin() {
  return request({
    url: "/api/checkLogin",
    method: "get",
  });
}
